import { NextSeo } from 'next-seo';
import ServicesPage from '_components/composed/pages/ServicesPage';

export default function Services() {
  return (
    <>
      <NextSeo title="Our Services" />
      <ServicesPage />
    </>
  );
}
